import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../baseUrl";

const initialState = {
  faqHotels: {},
  loading: false,
  error: null,
};

export const fetchFaqHotels = createAsyncThunk(
  "faqHotels/fetchFaqHotels",
  async ({ hotelUrl, language }) => {
    const response = await axios.get(
      `${baseUrl}/api/Hotels/HotelFAQ/${language}/${hotelUrl}`
    );
    return response.data;
  }
);

const faqHotelsSlice = createSlice({
  name: "faqHotels",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchFaqHotels.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFaqHotels.fulfilled, (state, action) => {
        state.loading = false;
        state.faqHotels = action.payload;
      })
      .addCase(fetchFaqHotels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default faqHotelsSlice.reducer;
